import { CommonSystemError, CommonSystemErrorCodeList, CommonSystemErrorRegistry, } from "@ascend-ltd/logic-helpers";
export const SystemErrorCodeList = [...CommonSystemErrorCodeList];
export const SystemError = {
    ...CommonSystemError,
};
export const SystemErrorRegistry = {
    ...CommonSystemErrorRegistry,
};
//# sourceMappingURL=system-error.js.map